import { render } from "./AdminRateDetail.vue?vue&type=template&id=e513e3fe&scoped=true&ts=true&lang=true"
import script from "./AdminRateDetail.vue?vue&type=script&lang=ts"
export * from "./AdminRateDetail.vue?vue&type=script&lang=ts"

import "./AdminRateDetail.vue?vue&type=style&index=0&id=e513e3fe&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e513e3fe"]])

export default __exports__